import { Switch } from "@mui/material";
import { SettingsItemLabel } from "./UserSettings.style";
import { OrganizationContext, useTranslation } from "hhn-commons";
import { useContext } from "react";

export const DoNotDisturb = () => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "settings" });

  const { selectedOrgUser } = useContext(OrganizationContext);

  const toggleDoNotDisturb = () => {
    if (selectedOrgUser) {
      selectedOrgUser.updateDoNotDisturb(!selectedOrgUser.onDND());
    }
  };

  return (
    <>
      {selectedOrgUser && (
        <>
          <Switch
            slotProps={{
              input: {
                "aria-label": "Do Not Disturb (DND)",
              },
            }}
            checked={selectedOrgUser?.onDND()}
            onChange={toggleDoNotDisturb}
          />
          <SettingsItemLabel>
            {tNs("userSettings.doNotDisturb")}
          </SettingsItemLabel>
        </>
      )}
    </>
  );
};
